<div class="row">
  <div class="col-12">
    <mat-card class="mcd-card view-all-detail-card">
      <mat-card-header class="mcd-card-header-dateModified">
        <mat-card-title style="font-weight: bold">
          <button
            style="
              background-color: #3f51b51a;
              color: #3f51b5;
              border: none;
              padding: 5px 11px;
              border-radius: 4px;
              font-weight: 600;
              font-size: 14px;
            "
            (click)="goBack()"
          >
            <img src="/assets/images/back to list.svg" />
            Back
          </button>
          <span>
            <img
              src="/assets/images/operation-standard.svg"
              style="margin-left: 16px; margin-right: 8px"
              />  
          </span>
          <span style="font-size: 16px;"
            >View Operation Standard</span
          ></mat-card-title
        >
      </mat-card-header>
      <mat-card-content class="mcd-card-content nrbes-view">
        <!-- new detail UI starts here  -->

        <div *ngIf="!loading" style="padding: 20px; background-color: #f7f9fa">
          <div class="review-page-container">
            <!-- Breadcrumb -->
            <div class="breadcrumbs clearfix">
              <div class="breadcrumbs-inner">
                <ul>
                  <li>
                    <a
                      routerLink="/view-all-standards"
                      routerLinkActive="active"
                      >All</a
                    >
                  </li>
                  <li class="separator">/</li>
                  <li class="active">{{ grsDetail?.standard?.title }}</li>
                  <li
                    style="
                      float: right;
                      border: 1px solid #3f51b5;
                      padding: 6px 10px;
                      border-radius: 4px;
                    "
                  >
                    <img
                      src="/assets/images/social-sharing 1.svg"
                      style="margin-right: 4px"
                    />

                    <a
                      style="
                        color: #3f51b5;
                        font-weight: 700;
                        text-decoration: none;
                        cursor: pointer;
                      "
                      (click)="openShareModal()"
                      >Share
                    </a>
                  </li>
                  <li
                    style="
                      float: right;
                      border: 1px solid #3f51b5;
                      padding: 6px 10px;
                      border-radius: 4px;
                      margin-right: 10px;
                    "
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style="margin-bottom: 2px; margin-right: 2px"
                    >
                      <path
                        d="M8.5 5V1H5.5V5H3.5L7 9L10.5 5H8.5Z"
                        stroke="#3C74E0"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.5 9V11.5C12.5 11.8978 12.342 12.2794 12.0607 12.5607C11.7794 12.842 11.3978 13 11 13H3C2.60218 13 2.22064 12.842 1.93934 12.5607C1.65804 12.2794 1.5 11.8978 1.5 11.5V9"
                        stroke="#3C74E0"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <a
                      style="
                        color: #3f51b5;
                        text-decoration: none;
                        cursor: pointer;
                        font-weight: 700;
                      "
                      (click)="downloadExcel()"
                      >Download Standard
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- End Breadcrumb -->
            <!-- <div class="header"> -->
            <!-- <div class="stamp">{{ data.stampText }}</div> -->
            <!-- </div> -->

            <div
              *ngIf="isPartlyInEffect"
              style="
                background-color: #eef1fc;
                border: 1px solid #d6ddf5;
                border-radius: 6px;
                padding: 12px 16px;
                margin-bottom: 16px;
              "
            >
              <div style="color: #3f51b5; font-weight: 700; font-size: 14px">
                This Standard is partly in effect
              </div>
              <div style="color: #555; font-size: 13px; margin-top: 2px;font-weight: 500">
                {{ partlyInEffectMessage }}
              </div>
            </div>

            <div
              *ngIf="showExemptionBanner"
              style="
                background-color: #e8f7ee;
                border: 1px solid #c7ebd6;
                border-radius: 6px;
                padding: 12px 16px;
                margin-bottom: 16px;
              "
            >
              <div style="color: #1e8e4e; font-weight: 700; font-size: 14px">
                {{ exemptionBannerTitle }}
              </div>
              <div style="color: #555; font-size: 13px; margin-top: 2px; font-weight: 500">
                {{ exemptionBannerMessage }}
              </div>
            </div>

            <div class="info-main">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 20px;
                "
              >
                <h1 class="lastpage-title">
                  {{ grsDetail?.standard?.title }}
                </h1>
                <img
                  *ngIf="hasActiveException"
                  src="/assets/images/exception active.svg"
                  alt="Exception Active"
                />
                <!-- <img src="../../assets/images/global-minium-badge.svg" /> -->
              </div>
              <div style="display: flex">
                <div class="info-column left-column">
                  <div class="info-row">
                    <span class="reviewPage-icon date"></span>
                    <span class="label left-label"
                      >New Restaurant Effective Date</span
                    >
                    <span class="value">{{
                      grsDetail?.standard?.newRestaurantsEffectiveFrom
                        ? (grsDetail.standard.newRestaurantsEffectiveFrom
                          | date: "dd, MMM yyyy")
                        : "--"
                    }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon date2"></span>
                    <span class="label left-label"
                      >Existing Restaurant Effective Date</span
                    >
                    <span class="value">{{
                      grsDetail?.standard?.effectiveFrom != ""
                        ? (grsDetail.standard.effectiveFrom
                          | date: "dd, MMM yyyy")
                        : "--"
                    }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon standardType"></span>
                    <span class="label left-label">Standard Type</span>
                    <span class="value"> Operation Standard</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon createdOn"></span>
                    <span class="label left-label">Last Updated</span>
                    <span class="value">{{
                      grsDetail?.standard?.lastModifiedDate | date: "dd, MMM yyyy"
                    }}</span>
                  </div>

                  <!-- <div class="info-row">
                                <span class="icon clock-icon"></span>
                                <span class="label">Last Modified</span>
                                <span class="value">{{
                                  data.lastModified
                                }}</span>
                              </div> -->
                </div>

                <div class="divider"></div>

                <div class="info-column right-column">
                  <div class="info-row">
                    <span class="reviewPage-icon category"></span>
                    <span class="label right-label">Category</span>
                    <span class="value">
                      {{ grsDetail.standard.category?.name }}
                    </span>
                    <!-- <span
                                    class="value"
                                   
                                    >
                                    {{ categoryForLastPage }}
                                    </span
                                  > -->
                  </div>
                  <div class="info-row">
                    <span class="reviewPage-icon location"></span>
                    <span class="label right-label">Location</span>
                    <span class="value">{{ allLocations }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon Sublocation"></span>
                    <span class="label right-label">Sub Location</span>
                    <span class="value">{{
                      subLocations != "" ? subLocations : "--"
                    }}</span>
                  </div>

                  <div class="info-row">
                    <span class="reviewPage-icon keyContact"></span>
                    <span class="label right-label">Key Contact</span>
                    <span class="value">{{
                      keyContactEmailResolved ? keyContactEmailResolved : "--"
                    }}</span>
                  </div>

                  <!-- <div class="info-row">
                                <span class="icon user-icon"></span>
                                <span class="label">Key Contact</span>
                                <span class="value">{{ data.keyContact }}</span>
                              </div> -->
                </div>
              </div>
            </div>
            <div class="description-section" *ngIf="isSameDescription">
              <div style="display: flex; align-items: center">
                <h2 class="section-title">Description</h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(grsDetail.standard.description);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>

              <p class="description-text">
                {{ grsDetail.standard.description }}
              </p>
            </div>

            <div
              class="description-wrapper"
              *ngIf="
                !isSameDescription &&
                (hasNewDescription || hasExistingDescription)
              "
              style="display: flex; gap: 20px"
            >
              <!-- New Restaurant -->
              <div
                class="description-section"
                *ngIf="hasNewDescription"
                style="flex: 1"
              >
                <div style="display: flex; align-items: center">
                  <h2 class="section-title">Description for New Restaurant</h2>
                  <button class="copyIcon">
                    <img
                      (click)="
                        copyText(grsDetail.standard.newRestaurantDescription);
                        $event.stopPropagation()
                      "
                      src="../../assets/images/copy text.svg"
                      alt=""
                    />
                  </button>
                </div>

                <p class="description-text">
                  {{ grsDetail.standard.newRestaurantDescription }}
                </p>
              </div>

              <!-- Existing Restaurant -->
              <div
                class="description-section"
                *ngIf="hasExistingDescription"
                style="flex: 1"
              >
                <div style="display: flex; align-items: center">
                  <h2 class="section-title">
                    Description for Existing Restaurant
                  </h2>
                  <button class="copyIcon">
                    <img
                      (click)="
                        copyText(grsDetail.standard.description);
                        $event.stopPropagation()
                      "
                      src="../../assets/images/copy text.svg"
                      alt=""
                    />
                  </button>
                </div>

                <p class="description-text">
                  {{ grsDetail.standard.description }}
                </p>
              </div>
            </div>

            <!-- <div class="description-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                "
              >
                <h2 class="section-title">Description for New Restaurant</h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(grsDetail.standard.newRestaurantDescription);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>
              <p class="description-text">
                {{ grsDetail.standard.newRestaurantDescription }}
              </p>
            </div>

            <div class="description-section">
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                "
              >
                <h2 class="section-title">
                  Description for Existing Restaurant
                </h2>
                <button class="copyIcon">
                  <img
                    (click)="
                      copyText(grsDetail.standard.description);
                      $event.stopPropagation()
                    "
                    src="../../assets/images/copy text.svg"
                    alt=""
                  />
                </button>
              </div>
              <p class="description-text">
                {{ grsDetail.standard.description }}
              </p>
            </div> -->

            <div class="details-section" style="margin-top: 20px">
              <div class="details-header" (click)="toggleDetails()">
                <div class="details-title-wrapper">
                  <div>
                    <span class="toggle-icon">
                      <img
                        *ngIf="!detailsExpanded"
                        src="../../assets/images/s-add 1.svg"
                        alt="Expand"
                        style="margin-bottom: 3px" />

                      <img
                        *ngIf="detailsExpanded"
                        src="../../assets/images/cross (2).svg"
                        alt="Collapse"
                        style="margin-bottom: 3px"
                    /></span>
                    <!-- <span class="details-icon">☑</span> -->
                    <span class="details-title"
                    [ngClass]="{ 'details-title-expanded': detailsExpanded }"
                      >Operation Standard Details
                    </span>
                  </div>
                  <div *ngIf="detailsExpanded">
                    <img
                      (click)="
                        copyText(grsDetail.standard.note);
                        $event.stopPropagation()
                      "
                      src="../../assets/images/copy text.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div class="details-content" [class.expanded]="detailsExpanded">
                <div [innerHTML]="getDetails()" class="detail-section"></div>
              </div>
            </div>

            <div
              class="details-section"
              style="margin-top: 20px"
              *ngIf="grsDetail.standard.additionalInformation"
            >
              <div class="details-header" (click)="toggleDetails2()">
                <div class="details-title-wrapper">
                  <div>
                    <span class="toggle-icon">
                      <img
                        [ngStyle]="{
                          display: additionalInfoExpanded ? 'none' : '',
                        }"
                        *ngIf="!additionalInfoExpanded"
                        src="../../assets/images/s-add 1.svg"
                        alt="Expand"
                        style="margin-bottom: 3px" />
                      <img
                        [ngStyle]="{
                          display: !additionalInfoExpanded ? 'none' : '',
                        }"
                        *ngIf="additionalInfoExpanded"
                        src="../../assets/images/cross (2).svg"
                        alt="Collapse"
                        style="margin-bottom: 3px"
                    /></span>
                    <!-- <span class="details-icon">☑</span> -->
                    <span class="details-title" [ngClass]="{ 'details-title-expanded': additionalInfoExpanded }"> Additional Info </span>
                  </div>
                  <div *ngIf="additionalInfoExpanded">
                    <img
                      (click)="
                        copyText(grsDetail.standard.additionalInformation);
                        $event.stopPropagation()
                      "
                      src="../../assets/images/copy text.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div
                class="details-content"
                [class.expanded]="additionalInfoExpanded"
              >
                <div
                  [innerHTML]="getAdditionalInfo()"
                  class="detail-section"
                ></div>
              </div>
            </div>

            <div
              *ngIf="
                linksList?.length > 0 ||
                hardwareDescription
              "
              class="bottom-sections"
              [class.single-column]="
                (linksList?.length > 0 &&
                  !hardwareDescription) ||
                (!(linksList?.length > 0) &&
                  hardwareDescription)
              "
            >
              <div
                class="resources-section"
                *ngIf="linksList?.length > 0"
              >
                <div class="section-header">
                  <h2 class="section-heading">
                    Resources and Supporting Information
                  </h2>
                  <span
                    matTooltip="Information about Resources and Supporting Information"
                    style="
                      background-image: url(&quot;/assets/images/Vector.svg&quot;);
                      background-repeat: no-repeat;
                      background-size: auto;
                      background-position: center;

                      padding: 10px;
                    "
                  ></span>
                </div>
                <div class="links-list">
                  <a
                    *ngFor="let link of linksList"
                    [href]="link.url"
                    class="resource-link"
                    target="_blank"
                  >
                    {{ link.title }}
                  </a>
                </div>
              </div>

              <div
                class="hardware-section"
                *ngIf="hardwareDescription"
              >
                <div class="section-header">
                  <h2 class="section-heading">
                    Global Approved Hardware/Equipment
                  </h2>
                  <span
                    matTooltip="Information about Global Approved Hardware/Equipment"
                    style="
                      background-image: url(&quot;/assets/images/Vector.svg&quot;);
                      background-repeat: no-repeat;
                      background-size: auto;
                      background-position: center;

                      padding: 10px;
                    "
                  ></span>
                </div>
                <div class="hardware-content">
                  <p
                    class="hardware-text"
                    style="margin: 0; white-space: pre-line;"
                  >
                    {{ hardwareDescription }}
                  </p>
                </div>
              </div>
            </div>

            <div class="gas-container">
              <!-- Header -->
              <div class="gas-header">
                <h2 class="gas-title">Global Approved Solutions</h2>
                <span
                  matTooltip="Information about Global Approved Solutions"
                  style="
                    background-image: url(&quot;/assets/images/Vector.svg&quot;);
                    background-repeat: no-repeat;
                    background-size: auto;
                    background-position: center;

                    padding: 10px;
                  "
                ></span>
                <!-- <button style="border: none;background: none;" title="Info">
                  <span> <img src="../../assets/images/tooltip icon.svg" alt="Info"> </span>
                </button> -->
              </div>

              <!-- Carousel body -->
              <div class="gas-body">
                <ng-container *ngIf="grsDetail.dependentStandards.length === 0">
                  <p class="gas-empty-message">
                    There are currently no Global Approved Solution for this
                    Standard
                  </p>
                </ng-container>

                <ng-container *ngIf="grsDetail.dependentStandards.length > 0">
                  <div class="gas-carousel">
                    <!-- Prev button -->
                    <button
                      class="gas-nav-btn gas-nav-prev"
                      [disabled]="!canPrev"
                      (click)="prev()"
                      [ngClass]="{ disabled: !canPrev }"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polyline points="15 18 9 12 15 6"></polyline>
                      </svg>
                    </button>

                    <!-- Viewport -->
                    <div class="gas-viewport">
                      <div
                        class="gas-track"
                        [style.transform]="getTransformStyle()"
                      >
                        <div
                          class="gas-card"
                          *ngFor="let item of grsDetail.dependentStandards"
                          routerLink="{{
                            '/global-recommendations-detail-view/' + item.id
                          }}"
                        >
                          <div class="gas-card-header">
                            <h3 class="gas-card-title">{{ item.title }}</h3>
                            <span class="gas-category-badge">{{
                              item.category.name
                            }}</span>
                          </div>
                          <p class="gas-card-description">
                            {{ item.description }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- Next button -->
                    <button
                      class="gas-nav-btn gas-nav-next"
                      [disabled]="!canNext"
                      (click)="next()"
                      [ngClass]="{ disabled: !canNext }"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </button>
                  </div>

                  <!-- Dot indicators -->
                  <div class="gas-indicators">
                    <button
                      class="gas-dot"
                      *ngFor="
                        let i of [].constructor(maxIndex + 1);
                        let idx = index
                      "
                      [ngClass]="{ active: idx === currentIndex }"
                      (click)="goToSlide(idx)"
                    ></button>
                  </div>
                </ng-container>
              </div>
            </div>

            <!-- <div
              style="
                border-bottom: 1px solid #dde1e6;
                border-left: 1px solid #dde1e6;
                border-right: 1px solid #dde1e6;
                border-radius: 8px;
                margin-top: 20px;
              "
            >
              <div class="section-header">
                <h2 class="section-heading">Global Approved Solutions</h2>
                <span class="info-icon-circle">?</span>
              </div>
              <div class="links-list">
                <div class="dmos-cards-grid">
                  <div
                    class="dmos-standard-card"
                    *ngIf="grsDetail.dependentStandards.length == 0"
                  >
                    <p style="text-align: center; margin-bottom: 0">
                      There are currently no Global Approved Solution for this
                      Standard
                    </p>
                  </div>
                  <div
                    class="dmos-standard-card"
                    *ngFor="let item of grsDetail.dependentStandards"
                  >
                    <div class="dmos-card-header">
                      <h3 class="dmos-card-title">
                        {{ item.title }}
                      </h3>
                      <span class="dmos-category-badge dmos-building-site">{{
                        item.category.name
                      }}</span>
                    </div>
                    <div class="dmos-card-body">
                      <p class="dmos-card-description">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="row" style="margin-top: 30px">
              <div class="btn-wrapper" style="display: flex; gap: 20px">
                <div class="prev-button" *ngIf="!grsDetail.isFirst">
                  <a
                    class="nextPrevButtons"
                    href="javascript:void(0)"
                    (click)="slide(grsDetail.standard.id, false)"
                  >
                    <img src="/assets/images/arrow-right 2.svg" />
                    Previous Standard
                  </a>
                </div>
                <div class="next-button" *ngIf="!grsDetail.isLast">
                  <a
                    class="nextPrevButtons"
                    href="javascript:void(0)"
                    (click)="slide(grsDetail.standard.id, true)"
                  >
                    Next Standard
                    <img src="/assets/images/arrow-right 1 (2).svg" />
                  </a>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <button
                    class="mcd-btn mcd-btn-primary"
                    [disabled]="grsDetail.isInNrbes"
                    *ngIf="userRole == userRoleEnum.MarketAdmin && !isImpersonating"
                    (click)="
                      addToNrbes(
                        grsDetail.standard.id,
                        grsDetail.standard.standardTypeId
                      )
                    "
                    mat-raised-button
                    color="accent"
                  >
                    Add To National Standard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- new detail UI ends here -->

        <!-- <div class="nrbes-detail-view table-list" *ngIf="loading == false">
          <h3>Global Approved Solutions</h3>
          <table
            class="table nrbes-grid"
            *ngIf="grsDetail.dependentStandards.length > 0"
          >
            <thead class="thead-light">
              <tr>
                <th scope="140">Title</th>
                <th width="140" scope="col">Type</th>
                <th scope="col" width="110">Location</th>
                <th scope="col-4" width="30%">Description</th>
                <th scope="col-2">Category</th>

                <th
                  *ngIf="
                    userRole == userRoleEnum.GlobalAdmin &&
                    !standardService.isGrs
                  "
                  scope="col"
                  width="80"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of grsDetail.dependentStandards"
                (click)="rowSelected(item)"
              >
                <td class="date-cell">{{ item.title }}</td>
                <td class="title-cell">{{ item.standardType.name }}</td>
                <td class="location-cell">{{ getLocationNames(item) }}</td>
                <td class="description">
                  <span class="description">
                    {{ item.description }}
                  </span>
                </td>
                <td class="category-cell">{{ item.category.name }}</td>

                <td
                  *ngIf="
                    userRole == userRoleEnum.GlobalAdmin &&
                    !standardService.isGrs
                  "
                >
                  <div class="row grid-actions hide-sm">
                    <div class="col-6">
                      <a
                        class="action-controls"
                        (click)="openDeleteModal(item.id, $event)"
                        routerLinkActive="active"
                        title="clear"
                      >
                        <i class="material-icons"> clear </i>
                      </a>
                    </div>
                    <div class="col-6">
                      <a
                        class="action-controls"
                        (click)="onEdit(item.id)"
                        routerLinkActive="active"
                        title="Edit"
                        href="javascript:void(0);"
                        ><i class="material-icons"> create </i></a
                      >
                    </div>
                  </div>

                  <a
                    (click)="actionMenuOpen($event)"
                    class="mcd-more-btn show-sm"
                    [matMenuTriggerFor]="menu"
                    href="javascript:void(0);"
                  >
                    <i class="material-icons">more_vert</i>
                  </a>
                  <mat-menu #menu="matMenu" overlapTrigger="false">
                    <span>
                      <button
                        mat-menu-item
                        (click)="onEdit(item.id)"
                        routerLinkActive="active"
                        title="Edit"
                      >
                        Edit
                      </button>
                      <button
                        mat-menu-item
                        (click)="
                          closeMatMenuAndOpenDeleteModal(item.id, $event)
                        "
                      >
                        Remove
                      </button>
                    </span>
                  </mat-menu>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="grsDetail.dependentStandards.length == 0">
            Sorry you do not have any Global Approved Solutions.
          </div>
        </div> -->
      </mat-card-content>
    </mat-card>
  </div>
  <!-- <div class="col-3">
    <app-sideView-GloabalApprovedSolutions
      *ngIf="!gapLoading"
      [inputData]="this.grsDetail"
    ></app-sideView-GloabalApprovedSolutions>
  </div> -->
  <app-mcd-loader *ngIf="loading"></app-mcd-loader>
  <app-share-link-modal
    *ngIf="isShareModalOpen"
    [itemTitle]="shareModalTitle"
    [itemSubtitle]="shareModalSubtitle"
    [shareUrl]="shareModalUrl"
    (closeModal)="isShareModalOpen = false"
  ></app-share-link-modal>
</div>
